export const PANEL_ID_PREFIX = 'step_panel_';
export const TAB_ID_PREFIX = 'step_tab_';
